import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";
import { toast } from "react-toastify";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";


import { CustomToastContent } from "../../../../examples/CustomToastContent/index";

// @mui material components
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Backdrop } from "@mui/material";

import { CSVLink } from "react-csv";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";


import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component
import Select from "react-select";

// Custom standard components
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import CreateTestRecordModal from "../CreateTestRecordModal/index";

import {
  getNotchImpactTest,
  createNotchImpactTest,
  editNotchImpactTest,
  deleteNotchImpactTest,
  getProductsListForDpp,
  getSubModulesByRoleId,
  uploadCsvForNotchImpact,
} from "../../../../store";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "scroll",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 750 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
  overflow: "hidden",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const NotchImpactTest = ({
  getNotchImpactTestReducer,
  getNotchImpactTest,
  createNotchImpactTest,
  editNotchImpactTest,
  deleteNotchImpactTest,
  dppIdSelectedForGlobalFilter,
  dropdownUI,
  getProductsListForDpp,
  getProductsListForDppReducer,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  uploadCsvForNotchImpact,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let userId = loginDetails?.data?.userId;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "a5fde116-00b7-4ce0-939b-2482c5d161e1",
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "896c7b19-7fe5-4306-9f06-2735e57a7b84",
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "9acd851e-2dc1-4bd1-a480-e7621d85ace8",
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "483ae968-cc38-4d30-ba63-887e9d32ba71",
    )
    : null;

  const [loading, setLoading] = useState(true);

  // For DPP Dropdown Options
  const [dppOptions, setDPPOptions] = useState([]);
  const [dppIdSelected, setdppIdSelected] = useState("");
  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");

  // Fetch Initial Data
  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      getNotchImpactTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      getNotchImpactTest(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);

  useEffect(() => {
    getProductsListForDpp(jwtToken);
  }, [jwtToken]);
  useEffect(() => {
    let tempDppOptions = [];
    let dataList = getProductsListForDppReducer?.productsListForDpp?.data
      ? getProductsListForDppReducer.productsListForDpp.data
      : [];

    dataList.forEach((item) => {
      tempDppOptions.push({
        label: item.dppCode,
        value: item.dppId,
      });
    });

    setDPPOptions(tempDppOptions);
  }, [getProductsListForDppReducer]);

  // DataTable State
  const [state, setState] = useState({
    columns: [
      { Header: "Test ID", accessor: "notchImpactId" },
      { Header: "DPP Code", accessor: "dppCode" },
      { Header: "Strength (Mean)(kJ/m²)", accessor: "notchImpactStrengthMean" },
      {
        Header: "Strength (Indv) (kJ/m²)",
        accessor: "notchImpactStrengthIndividualValues",
      },
      { Header: "Work Mean (kJ/m²)", accessor: "notchImpactWorkMean" },
      { Header: "Sample Width", accessor: "smapleWidth" },
      { Header: "Sample Type", accessor: "sampleType" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;



  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Strength Mean (kJ/m²)", key: "notchImpactStrengthMean" },
    { label: "Strength Indv Values", key: "notchImpactStrengthIndividualValues" },
    { label: "Work Mean (kJ/m²)", key: "notchImpactWorkMean" },
    { label: "Sample Width", key: "smapleWidth" },
    { label: "Sample Type", key: "sampleType" }
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "notchImpactStrengthMean", key: "notchImpactStrengthMean" },
    { label: "notchImpactStrengthIndividualValues", key: "notchImpactStrengthIndividualValues" },
    { label: "notchImpactWorkMean", key: "notchImpactWorkMean" },
    { label: "sampleWidth", key: "smapleWidth" },
    { label: "sampleType", key: "sampleType" }
  ];

  const csvLink = {
    filename: "Notch Impact Test List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Notch Impact Upload Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [showUploadPanel, setShowUploadPanel] = useState(false);
  const [uploadCsvData, setUploadCsvData] = useState(null);

  const handleUploadClick = () => {
    setShowUploadPanel(!showUploadPanel);
    setUploadCsvData(null);
  };
 
  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadCsvForNotchImpact(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        setShowUploadPanel(false);
        setUploadCsvData(null);

        let filterId = dppIdSelectedForGlobalFilter?.value || null;
        getNotchImpactTest(filterId, jwtToken);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };

  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  // Map Data to Table Rows
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getNotchImpactTestReducer?.notchImpactTest?.data
      ? getNotchImpactTestReducer.notchImpactTest.data
      : [];

    setLoading(getNotchImpactTestReducer?.loading || false);

    data.map((item) => {
      const itemObject = {
        notchImpactId: item.notchImpactId,
        dppId: item.dppId,
        dppCode: item.dppCode,
        notchImpactStrengthMean: item.notchImpactStrengthMean,
        notchImpactStrengthIndividualValues:
          item.notchImpactStrengthIndividualValues,
        notchImpactWorkMean: item.notchImpactWorkMean,
        smapleWidth: item.smapleWidth,
        sampleType: item.sampleType,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => handleOpenUpdateModal(item)}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    setState((prevState) => ({ ...prevState, rows: tempMappedActivity }));
  }, [getNotchImpactTestReducer]);

  // ================= CREATE LOGIC =================
  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [allocateButtonName, setAllocateButtonName] = useState("Create");
  const [openCreateModal, setOpenCreateModal] = useState(false);

  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);
    formik.setErrors({});
  };

  const handleCloseAllocateItemModal = () => {
    setAllocateItemModal(false);
    formik.setErrors({});
    formik.resetForm();
    setdppIdSelected("");
  };

  useEffect(() => {
    if (isSuccessAllocateItem)
      setTimeout(() => setIsSuccessAllocateItem(false), 3000);
    if (isErrorAllocateItem)
      setTimeout(() => setIsErrorAllocateItem(false), 3000);
  }, [isSuccessAllocateItem, isErrorAllocateItem]);

  const initialValues = {
    DPPID: "",
    notchImpactStrengthMean: "",
    notchImpactStrengthIndividualValues: "",
    notchImpactWorkMean: "",
    smapleWidth: "",
    sampleType: "",
  };

  const validationSchema = Yup.object({
    DPPID: Yup.object().required("Select DPP Code"),
    notchImpactStrengthMean: Yup.number()
      .typeError("Must be a number")
      .required("Required"),
    notchImpactStrengthIndividualValues: Yup.number()
      .typeError("Must be a number")
      .required("Required"),
    notchImpactWorkMean: Yup.number()
      .typeError("Must be a number")
      .required("Required"),
    smapleWidth: Yup.number()
      .typeError("Must be a number")
      .required("Required"),
    sampleType: Yup.string().required("Required"),
  });

  const onSubmit = async (values, { resetForm }) => {
    setAllocateButtonName("Please wait...");
    const payload = {
      dppId: values.DPPID?.value,
      notchImpactStrengthMean: String(values.notchImpactStrengthMean),
      notchImpactStrengthIndividualValues: String(
        values.notchImpactStrengthIndividualValues,
      ),
      notchImpactWorkMean: String(values.notchImpactWorkMean),
      smapleWidth: String(values.smapleWidth),
      sampleType: values.sampleType,
      cdBy: userId || "system",
    };

    let res = await createNotchImpactTest(payload, jwtToken);

    if (res.status) {
      setIsSuccessAllocateItem(true);
      getNotchImpactTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2000);
    } else {
      setErrorMsg(res?.data?.msg || "Something went wrong");
      setIsErrorAllocateItem(true);
      setAllocateButtonName("Create");
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });

  // ================= EDIT LOGIC =================
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [singleDataForUpdate, setSingleDataForUpdate] = useState({});
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");
  const [editButtonName, setEditButtonName] = useState("Update");

  const handleOpenUpdateModal = (data) => {
    setSingleDataForUpdate(data);
    setdppIdForUpdateSelected({ label: data.dppCode, value: data.dppId });
    setOpenUpdateModal(true);
  };

  const handleCloseUpdateModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setOpenUpdateModal(false);
    formikForUpdate.resetForm();
  };

  useEffect(() => {
    if (isSuccessForUpdate)
      setTimeout(() => setIsSuccessForUpdate(false), 3000);
    if (isErrorForUpdate) setTimeout(() => setIsErrorForUpdate(false), 3000);
  }, [isSuccessForUpdate, isErrorForUpdate]);

  const initialValueForUpdate = {
    notchImpactId: singleDataForUpdate.notchImpactId || "",
    DPPID: singleDataForUpdate.dppCode || "",
    notchImpactStrengthMean: singleDataForUpdate.notchImpactStrengthMean || "",
    notchImpactStrengthIndividualValues:
      singleDataForUpdate.notchImpactStrengthIndividualValues || "",
    notchImpactWorkMean: singleDataForUpdate.notchImpactWorkMean || "",
    smapleWidth: singleDataForUpdate.smapleWidth || "",
    sampleType: singleDataForUpdate.sampleType || "",
  };

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    const payload = {
      notchImpactId: values.notchImpactId,
      dppId: singleDataForUpdate.dppId,
      notchImpactStrengthMean: String(values.notchImpactStrengthMean),
      notchImpactStrengthIndividualValues: String(
        values.notchImpactStrengthIndividualValues,
      ),
      notchImpactWorkMean: String(values.notchImpactWorkMean),
      smapleWidth: String(values.smapleWidth),
      sampleType: values.sampleType,
      udBy: userId || "system",
    };

    let res = await editNotchImpactTest(payload, jwtToken);

    if (res.status) {
      setIsSuccessForUpdate(true);
      getNotchImpactTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseUpdateModal();
        setEditButtonName("Update");
      }, 2000);
    } else {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.msg || "Failed to update");
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    enableReinitialize: true,
  });

  // ================= DELETE LOGIC =================
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [isSuccessForDelete, setIsSuccessForDelete] = useState(false);
  const [isErrorForDelete, setIsErrorForDelete] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState("");
  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const handleOpenDeleteModal = (data) => {
    setSingleDataForDelete(data);
    setOpenDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  useEffect(() => {
    if (isSuccessForDelete)
      setTimeout(() => setIsSuccessForDelete(false), 2000);
    if (isErrorForDelete) setTimeout(() => setIsErrorForDelete(false), 3000);
  }, [isSuccessForDelete, isErrorForDelete]);

  const deleteRecord = async () => {
    setDeleteButtonName("Please wait...");
    let testId = singleDataForDelete.notchImpactId;
    let udBy = userId || "system";

    let res = await deleteNotchImpactTest(testId, udBy, jwtToken);

    if (res.status) {
      setIsSuccessForDelete(true);
      getNotchImpactTest(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 2000);
    } else {
      setIsErrorForDelete(true);
      setErrorMsgForDelete(res?.data?.msg || "Failed to delete");
      setDeleteButtonName("Delete");
    }
  };

  return (
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* Header Actions */}
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={4} display="flex" alignItems="center">
                {allocateAccess && (
                  <MDBox display="flex" alignItems="center">

                    <Tooltip>
                      <CreateButton tooltip="Add Notch Impact Test" onClick={() => setOpenCreateModal(true)}>
                        <Icon>add</Icon>
                      </CreateButton>
                    </Tooltip>

                    <CSVLink {...csvLink}>
                      <DownloadDataButton
                        tooltip="Download Notch Impact Test List"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </DownloadDataButton>
                    </CSVLink>



                    <UploadButton
                      tooltip="Upload CSV"
                      style={{ marginLeft: "1rem", marginTop: "2px" }}
                      type="button"
                      variant={showUploadPanel ? "contained" : "outlined"}
                      color="info"
                      iconOnly
                      onClick={handleUploadClick}
                    >
                      <Icon>upload</Icon>
                    </UploadButton>

                    <CSVLink {...csvLink2}>
                      <DownloadButton
                        tooltip="Download Template"
                        style={{ marginLeft: "1rem" }}
                        type="button"
                        variant="outlined"
                        color="error"
                        iconOnly
                      >
                        <Icon>description</Icon>
                      </DownloadButton>
                    </CSVLink>

                    {showUploadPanel && (
                      <MDBox
                        display="flex"
                        alignItems="center"
                        ml={2}
                        p={0.5}
                        px={2}
                      >
                        <input
                          className="choose_file"
                          type="file"
                          accept=".csv"
                          onChange={(e) => setUploadCsvData(e.target.files[0])}
                          style={{ width: "200px" }}
                        />

                        <MDButton
                          disabled={!uploadCsvData?.name || uploadCsvData?.type !== "text/csv"}
                          variant="contained"
                          color="info"
                          style={{ marginLeft: "1rem" }}
                          onClick={uploadCsvHandler}
                        >
                          UPLOAD
                        </MDButton>

                        <IconButton
                          size="small"
                          onClick={() => setShowUploadPanel(false)}
                          style={{ marginLeft: "10px", color: "gray" }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </MDBox>
                    )}

                  </MDBox>
                )}
              </MDBox>

              <MDBox mb={4} mr={1}>
                {dropdownUI}
              </MDBox>
            </MDBox>
            {/* DataTable */}
            <MDBox pt={0}>
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25],
                }}
                showTotalEntries={true}
                noEndBorder
              />
            </MDBox>
            {/* CREATE MODAL */}
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Notch Impact Test Record
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginLeft: "-55px",
                      }}
                      onClick={handleCloseAllocateItemModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            DPP Code
                          </MDTypography>
                          <Select
                            isClearable
                            className="select-css"
                            placeholder="Choose one..."
                            name="DPPID"
                            value={dppIdSelected}
                            options={dppOptions}
                            onBlur={() =>
                              formik.handleBlur({ target: { name: "DPPID" } })
                            }
                            onChange={(selectedOption) => {
                              setdppIdSelected(selectedOption);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Strength Mean
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchImpactStrengthMean"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.notchImpactStrengthMean}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.notchImpactStrengthMean &&
                              Boolean(formik.errors.notchImpactStrengthMean)
                            }
                          />
                          {formik.touched.notchImpactStrengthMean &&
                            formik.errors.notchImpactStrengthMean && (
                              <TextError
                                msg={formik.errors.notchImpactStrengthMean}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Strength Indv Values
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchImpactStrengthIndividualValues"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={
                              formik.values.notchImpactStrengthIndividualValues
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched
                                .notchImpactStrengthIndividualValues &&
                              Boolean(
                                formik.errors
                                  .notchImpactStrengthIndividualValues,
                              )
                            }
                          />
                          {formik.touched.notchImpactStrengthIndividualValues &&
                            formik.errors
                              .notchImpactStrengthIndividualValues && (
                              <TextError
                                msg={
                                  formik.errors
                                    .notchImpactStrengthIndividualValues
                                }
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Work Mean</MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchImpactWorkMean"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.notchImpactWorkMean}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.notchImpactWorkMean &&
                              Boolean(formik.errors.notchImpactWorkMean)
                            }
                          />
                          {formik.touched.notchImpactWorkMean &&
                            formik.errors.notchImpactWorkMean && (
                              <TextError
                                msg={formik.errors.notchImpactWorkMean}
                              />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Sample Width</MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="smapleWidth"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter value"
                            value={formik.values.smapleWidth}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.smapleWidth &&
                              Boolean(formik.errors.smapleWidth)
                            }
                          />
                          {formik.touched.smapleWidth &&
                            formik.errors.smapleWidth && (
                              <TextError msg={formik.errors.smapleWidth} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Sample Type</MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="sampleType"
                            fullWidth
                            autoComplete="off"
                            placeholder="Enter type"
                            value={formik.values.sampleType}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.sampleType &&
                              Boolean(formik.errors.sampleType)
                            }
                          />
                          {formik.touched.sampleType &&
                            formik.errors.sampleType && (
                              <TextError msg={formik.errors.sampleType} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsErrorAllocateItem(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsSuccessAllocateItem(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                        <MDBox mt={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            fullWidth
                            disabled={allocateButtonName === "Please wait..."}
                          >
                            {allocateButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            {/* UPDATE MODAL */}
            <Modal open={openUpdateModal} onClose={handleCloseUpdateModal}>
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update Notch Impact Test
                  </MDTypography>
                  <Tooltip title="Close">
                    <IconButton
                      style={{
                        background: "whitesmoke",
                        color: "black",
                        borderRadius: 5,
                        marginRight: "10px",
                        marginTop: "4px",
                      }}
                      onClick={handleCloseUpdateModal}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">DPP Code</MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="DPPID"
                            fullWidth
                            disabled={true}
                            value={formikForUpdate.values.DPPID}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Strength Mean
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchImpactStrengthMean"
                            fullWidth
                            value={
                              formikForUpdate.values.notchImpactStrengthMean
                            }
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">
                            Strength Indv Values
                          </MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchImpactStrengthIndividualValues"
                            fullWidth
                            value={
                              formikForUpdate.values
                                .notchImpactStrengthIndividualValues
                            }
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Work Mean</MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="notchImpactWorkMean"
                            fullWidth
                            value={formikForUpdate.values.notchImpactWorkMean}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Sample Width</MDTypography>
                          <MDInput
                            size="small"
                            type="number"
                            name="smapleWidth"
                            fullWidth
                            value={formikForUpdate.values.smapleWidth}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={6}>
                        <MDBox mb={1} ml={1}>
                          <MDTypography variant="h6">Sample Type</MDTypography>
                          <MDInput
                            size="small"
                            type="text"
                            name="sampleType"
                            fullWidth
                            value={formikForUpdate.values.sampleType}
                            onChange={formikForUpdate.handleChange}
                          />
                        </MDBox>
                      </Grid>

                      <Grid item xs={12}>
                        <Collapse in={isErrorForUpdate}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsErrorForUpdate(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsgForUpdate}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForUpdate}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                size="small"
                                onClick={() => setIsSuccessForUpdate(false)}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Updated successfully
                          </Alert>
                        </Collapse>
                        <MDBox mt={2}>
                          <MDButton
                            color="info"
                            type="submit"
                            fullWidth
                            disabled={editButtonName === "Please wait..."}
                          >
                            {editButtonName}
                          </MDButton>
                        </MDBox>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            {/* DELETE MODAL */}
            <Modal open={openDeleteModal} onClose={handleCloseDeleteModal}>
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2} display="flex" justifyContent="space-between">
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    color="error"
                    onClick={deleteRecord}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isErrorForDelete}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          size="small"
                          onClick={() => setIsErrorForDelete(false)}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {errorMsgForDelete}
                    </Alert>
                  </Collapse>
                  <Collapse in={isSuccessForDelete}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          size="small"
                          onClick={() => setIsSuccessForDelete(false)}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Deleted Successfully
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>
            <CreateTestRecordModal
              open={openCreateModal}
              handleClose={() => setOpenCreateModal(false)}
              jwtToken={jwtToken}
              userId={userId}
              dppOptions={dppOptions}
              onSuccessRefresh={(testTypeCreated) => { }}
            />
          </Grid>
        </Grid>
      </MDBox>

      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  getNotchImpactTestReducer: state.getNotchImpactTestReducer,
  getProductsListForDppReducer: state.getProductsListForDppReducer,
  getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
});

const mapDispatchToProps = (dispatch) => ({
  getSubModulesByRoleId: (roleId, jwtToken) =>
    dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  getNotchImpactTest: (dppId, jwtToken) =>
    dispatch(getNotchImpactTest(dppId, jwtToken)),
  createNotchImpactTest: (payload, jwtToken) =>
    dispatch(createNotchImpactTest(payload, jwtToken)),
  editNotchImpactTest: (payload, jwtToken) =>
    dispatch(editNotchImpactTest(payload, jwtToken)),
  deleteNotchImpactTest: (testId, udBy, jwtToken) =>
    dispatch(deleteNotchImpactTest(testId, udBy, jwtToken)),
  getProductsListForDpp: (dppId, jwtToken) =>
    dispatch(getProductsListForDpp(dppId, jwtToken)),
  uploadCsvForNotchImpact: (payload, jwtToken) =>
    dispatch(uploadCsvForNotchImpact(payload, jwtToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotchImpactTest);
